import { render, staticRenderFns } from "./gdMap.vue?vue&type=template&id=022be079&scoped=true"
import script from "./gdMap.vue?vue&type=script&lang=js"
export * from "./gdMap.vue?vue&type=script&lang=js"
import style0 from "./gdMap.vue?vue&type=style&index=0&id=022be079&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022be079",
  null
  
)

export default component.exports